import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=2c5f0628&scoped=true"
import script from "./Shipping.vue?vue&type=script&lang=js"
export * from "./Shipping.vue?vue&type=script&lang=js"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=2c5f0628&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f0628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5f0628')) {
      api.createRecord('2c5f0628', component.options)
    } else {
      api.reload('2c5f0628', component.options)
    }
    module.hot.accept("./Shipping.vue?vue&type=template&id=2c5f0628&scoped=true", function () {
      api.rerender('2c5f0628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/Shipping.vue"
export default component.exports